export const MAX_RETRY_ATTEMPTS = 6
export const { API_URL } = process.env
export const SUPPORTED_LANGUAGES = new Set(['en', 'fi', 'sv'])
export const LATEST_PRIVACY_POLICY_URL =
  'https://evexia-policies.s3.eu-west-1.amazonaws.com/Privacy%20policy%20v1.docx.pdf'
export const LATEST_TERMS_URL = 'https://evexia-policies.s3.eu-west-1.amazonaws.com/Terms%20and%20conditions%20v1.pdf'
